import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import PrimaryResourcesCategoryView from "../components/PrimaryResourcesCategoryView"
import PDFLogo from "../images/pdf.svg"
import ZipLogo from "../images/zip.svg"
import Grade3TB from "../images/primary-3.jpg"

class Primary3Resources extends React.Component {
  state = {
    view: {
      title: "Primary 3 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Grade3TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G3-Primary-3-TB_WM_2022.pdf",
        },
        {
          name: "Flashcards",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-3-jan-2021/",
          files: [
            {
              name: "Grade 3 Flashcards",
              file: "LBY0033_G3_Flashcards_WEB_2021.pdf",
            },
          ],
        },
        {
          name: "Posters",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-3-jan-2021/",
          files: [
            {
              name: "Grade 3 Alphabet LC Poster",
              file: "LBY0033_G3_Poster_1_Alphabet_LC_2021.pdf",
            },
            {
              name: "Grade 3 Colours and Numbers Poster",
              file: "LBY0033_G3_Poster_2_Colours_Numbers_2021.pdf",
            },
            {
              name: "Grade 3 Alphabet LC and UC Poster",
              file: "LBY0033_G3_Poster_3_Alphabet_LC_UC_2021.pdf",
            },
            {
              name: "Grade 3 House Poster",
              file: "LBY0033_G3_Poster_4_House_2021.pdf",
            },
            {
              name: "Grade 3 Body Poster",
              file: "LBY0033_G3_Poster_5_Body_2021.pdf",
            },
          ],
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Grade 3 Audio", file: "Primary-3-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        {/* need to switch this back to PrimaryResourcesCategoryView when add posters etc */}
        <PrimaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Primary3Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrimary3.js